<template>
  <!-- Navbar -->
  <div
    class="navbar-fixed-top"
    :style="{
      backgroundImage: `url(${require('@/assets/img/app/header-bg.png')})`,
    }"
  >
    <nav
      class="top-0 navbar navbar-expand-lg position-absolute z-index-3 navbar-transparent w-100 blur py-2 start-0 end-0 shadow"
    >
      <div class="container">
        <router-link
          class="navbar-brand font-weight-bolder ms-lg-0 ms-3 text-black"
          to="/service/main-chat"
          ><img
            :src="require('@/assets/img/auth/MI-chao_logo_menu.png')"
            style="width: 110px"
            alt="Logo"
          />
        </router-link>
        <div
          id="navigation"
          class="pt-3 pb-2 collapse navbar-collapse w-100 py-lg-0"
        >
          <div class="text-end w-100">
            <div class="figure text-white fw-bold me-5">
              {{ this.botName }}
            </div>
            <!--
            <button @click="goToTop()" class="btn btn-orange py-3 mb-0">
              <i class="fas fa-undo-alt me-1"></i> チャットボット一覧に戻る
            </button>
            -->
          </div>
        </div>
      </div>
    </nav>
  </div>
  <div class="rag-chat">
    <!-- sidenav -->
    <sidenav
      :custom-class="'bg-white'"
      :class="['position-fixed', 'fixed-start']"
      :style="{ zIndex: this.$store.state.isSidenavOpen ? 100 : '' }"
      :conversations="conversations"
      :isDeleteMode="isDeleteMode"
      @conversation-init="handleInitChat"
      @conversation-selected="handleConversation"
      @conversation-deleted="handleConfirmDeleteConversation"
      @handle-delete-mode="handleDeleteMode"
    >
    </sidenav>
    <div class="container-fluid py-4">
      <div class="mt-5">
        <transition name="fade" mode="out-in">
          <default-card
            v-if="isDefaultCard"
            key="default"
            :attached-files="attachedFiles"
            :chatbots="chatbots"
            :initialSelectedBot="initialSelectedBot"
            :model="selectedModel"
            :modelLabel="selectedModelLabel"
            :modelOptions="selectedModelOptions"
            @bot-selected="handleBot"
            @remove-file="removeFile"
            @handle-dragover="handleDragOver"
            @handle-drop="handleDrop"
            @handle-selected-model="handleSelectedModel"
            @handle-selected-model-label="handleSelectedModelLabel"
            @upload-files="handleFileUpload"
            @input-message="handleSendMessage"
          />
          <chat-card
            v-else
            key="chat"
            :messages="messages"
            :attached-files="attachedFiles"
            :download-file="downloadFile"
            :parse-markdown="parseMarkdown"
            :chatbots="chatbots"
            :ragResult="ragResult"
            :initialSelectedBot="initialSelectedBot"
            :model="selectedModel"
            :modelLabel="selectedModelLabel"
            :modelOptions="selectedModelOptions"
            :is-history-loaded="isHistoryLoaded"
            :is-streaming="isStreaming"
            @stop-stream="stopStreaming"
            @bot-selected="handleBot"
            @remove-file="removeFile"
            @handle-dragover="handleDragOver"
            @handle-drop="handleDrop"
            @handle-selected-model="handleSelectedModel"
            @handle-selected-model-label="handleSelectedModelLabel"
            @upload-files="handleFileUpload"
            @send-message="handleSendMessage"
          />
        </transition>
      </div>
    </div>
    <ErrorPopup
      :show="showErrorPopup"
      :message="errorMessage"
      @close="closeErrorPopup"
    />
    <ConfirmDeleteBotPopup
      :show="showConfirmDeleteConversationPopup"
      @close="closeConfirmDeleteConversationPopup"
      @delete="closeConversation"
    />
    <ProcessingOverlay :show="isProcessing" />
  </div>
</template>

<script>
import { NAV_MASTER } from '@/constants/navMaster'
import HTTPService from '@/services/HTTPService.js'
//import StorageService from '@/services/StorageService.js'
import ErrorPopup from '@/components/ErrorPopup.vue'
import { v4 as uuidv4 } from 'uuid'
import { cilPaperclip, cilReload, cilSend, cilX } from '@coreui/icons'
import { marked } from 'marked'
import DOMPurify from 'isomorphic-dompurify'
import Sidenav from './components/Sidenav/Index.vue'
import ChatCard from './components/ChatCard.vue'
import DefaultCard from './components/DefaultCard.vue'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'

import Prism from 'prismjs'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-tsx'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-docker'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-cpp'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-visual-basic'
import ConfirmDeleteBotPopup from '@/components/ConfirmDeleteBotPopup.vue'
import { useAuthStore } from '@/store/auth'
import { getTenantId } from '@/constants/tenants'

export default {
  components: {
    ConfirmDeleteBotPopup,
    ProcessingOverlay,
    Sidenav,
    ChatCard,
    DefaultCard,
    ErrorPopup,
  },
  props: {
    conversation_id: {
      type: String,
      required: false,
    },
    style: {
      type: Object,
      default: () => ({
        botBackgroundColor: '#fff',
        botTextColor: 'black',
        chatbotHeading: 'Hello!',
        chatbotSubHeading: 'Ask me anything',
        firstMessage: 'Hello, what can I help you with?',
        headerBackgroundColor: '#001d61ff',
        headerTextColor: '#FFFFFF',
        image: null,
        inputPlaceholderText: 'What do these say?',
        promptDefaultText:
          'あなたはカスタマーサポートを補助するAIです。' +
          'あなたには様々な情報を与えますので、与えられた情報の内容から回答を生成してください。' +
          '質問の内容があなたに関係のない場合は、答えられない旨ユーザーに伝えてください。' +
          'また、ユーザーからの質問が与えられた情報から回答できない物であれば、情報が足りずに回答できない旨ユーザーに伝えて、' +
          'さらにより詳しい状況やキーワードをユーザーに入力するように、言ってください。' +
          'さらに、検索の精度を向上させるために、キーワード単体で入力することも有効な手段である旨、' +
          'ユーザーにアナウンスしてあげてください。' +
          '回答はできるだけわかりやすく詳細に教えてください。' +
          '回答の際には参照ファイルを提示してください。リンクは不要です。' +
          '回答の最後に"他に何かお手伝い出来ることはありますか？"と聞いてください。' +
          '見出しにchatgptのようにアイコンを付加してください。' +
          'また、出力内容はVue.jsでMarkdownからHTMLに変換される前提で整形してください。' +
          '具体的には以下の点を守ってください：' +
          '・コードブロックは「```」で囲み、言語名を指定してください（例：```javascript）。' +
          '・見出し（#, ##, ###）を適切に使用し、階層構造を明確にしてください。' +
          '・リンクは通常のMarkdown形式で出力してください（例：[ファイル名](/files/sample.pdf)）。' +
          '・表や箇条書きはMarkdownで正しく構文化してください。' +
          '・改行は\\nではなくMarkdownの改行規則を使用してください。' +
          '・特殊文字はエスケープせずに自然なMarkdown記法で出力してください。' +
          'これにより、marked・DOMPurify・Prismによる整形時に正しくレンダリングされます。',
        //'最後に、返却結果の末尾に「人数別平均待ち時間（時間帯別比較）」をJSON形式で出力してください。' +
        //'JSONのキー名は "waiting_time_comparison" とし、値として時間帯ごとの平均待ち時間を人数別に表してください。' +
        //'例：{"waiting_time_comparison": {"1人": {"9:00-12:00": 5, "12:00-15:00": 8}, "2人": {"9:00-12:00": 7, "12:00-15:00": 10}}}',
        promptPlaceholderText: 'Enter your prompt here.',
        promptLabelText: 'システムコンテキスト',
        sendButtonBackgroundColor: '#001d61ff',
        userBackgroundColor: '#001d61ff',
        userTextColor: '#FFFFFF',
        assistantName: 'Assistant',
        bot_id: 'preview',
      }),
    },
    name: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      messages: [],
      userInput: '',
      messageIndex: 0,
      conversationId: '',
      cilSend,
      cilPaperclip,
      cilReload,
      cilX,
      user: null,
      selectedModel: 'claude-haiku-5-5', // Default model
      selectedModelLabel: 'claude-haiku-5-5', // Default model
      selectedModelOptions: [
        { value: 'gpt-5.6-terra', label: 'gpt-5.6-terra（スピード重視）' },
        { value: 'gpt-6.1-sol', label: 'gpt-6.1-sol（思考重視）' },
        { value: 'claude-sonnet-5-5', label: 'claude-sonnet-5-5' },
        { value: 'claude-haiku-5-5', label: 'claude-haiku-5-5' },
      ],
      attachedFiles: [],
      promptValue: this.style.promptDefaultText,
      isPromptCollapsed: false, // Stop collapsed by default
      bot_id: '',
      delete_conversation_id: '',
      botName: '',
      isCreatingChatbot: false,
      isUpdatingChatbot: false,
      ragResult: [],
      showErrorPopup: false,
      showConfirmDeleteConversationPopup: false,
      errorMessage: '',
      chatbots: [],
      conversations: [],
      initialSelectedBot: null,
      isDefaultCard: true,
      isProcessing: false,
      maxPerFileMB: 50,
      maxPerImageFileMB: 15,
      isHistoryLoaded: false,
      abortController: null,
      isStreaming: false,
      isDeleteMode: false,
    }
  },
  async mounted() {
    //try {
    //  const response = await HTTPService.getuser()
    //  this.user = response.data.user
    //  if (!this.user) {
    //    // If the user is not authenticated, push them to the login route
    //    this.$router.push('/login')
    //  } else {
    //    await this.getChatbots()
    //  }
    //} catch (error) {
    //  console.error(error)
    //  // If there's an error or no user found, redirect to the login page
    //  this.$router.push('/login')
    //}
    await this.getChatbots()
    if (this.conversations.length >= 50) {
      await this.handleConversation(this.conversations[0].id)
    }
    marked.setOptions({
      silent: true,
      xhtml: true,
      breaks: true,
      gfm: true,
    })

    //this.messages.push({
    //  text: this.style.firstMessage,
    //  is_user: false,
    //})
    this.messageIndex = 1
    if (this.conversation_id !== '') {
      this.conversationId = this.conversation_id
    }

    if (this.$route.query.conversationId) {
      this.conversationId = this.$route.query.conversationId
    }

    if (!this.conversationId) {
      this.conversationId = uuidv4()
    } else {
      //this.startConversation()
    }

    document.addEventListener('click', this.handleFileClick)
  },
  computed: {
    initChatBot() {
      return this.$store.state.initChatBot
    },
    getImage() {
      return this.style.image
    },
    getAssistantName() {
      return this.style.assistantName
    },
    getHeading() {
      return this.style.chatbotHeading
    },
    getSubHeading() {
      return this.style.chatbotSubHeading
    },
    getHeadingStyle() {
      return {
        backgroundColor: this.style.headerBackgroundColor,
        color: this.style.headerTextColor,
      }
    },
    getSendButtonStyle() {
      const backgroundColor = this.style.sendButtonBackgroundColor

      return {
        backgroundColor,
        border: 'none',
        padding: '10px',
        marginRight: '10px',
      }
    },
    getInputMessage() {
      return this.style.inputPlaceholderText
    },
    getPromptMessage() {
      return this.style.promptPlaceholderText
    },
    getPromptLabel() {
      return this.style.promptLabelText
    },
    getUserMessageStyle() {
      return {
        backgroundColor: this.style.userBackgroundColor,
        color: this.style.userTextColor,
      }
    },
    getBotMessageStyle() {
      return {
        backgroundColor: this.style.botBackgroundColor,
        color: this.style.botTextColor,
      }
    },
    getAttachButtonStyle() {
      const backgroundColor = this.style.sendButtonBackgroundColor

      return {
        backgroundColor,
        border: 'none',
        padding: '10px',
        marginRight: '5px', // Margin between the buttons
      }
    },
    onModelChange() {
      console.log('Selected model:', this.selectedModel)
      return null
    },
    getDefaultPrompt() {
      return this.style.promptDefaultText
    },
  },
  methods: {
    goToTop() {
      this.$router.push('/chatbot-setting')
    },
    stopStreaming() {
      if (this.abortController) {
        this.abortController.abort()
        this.abortController = null
      }

      this.isStreaming = false
    },
    handleInitChat() {
      this.isDefaultCard = true
      this.conversationId = uuidv4()
      this.messages = []
    },
    async handleBot(botId) {
      // 表示中のRAGチャットボット以外を選択された場合
      if (this.bot_id !== botId) {
        this.isProcessing = true
        this.isDefaultCard = true
        this.bot_id = botId
        this.conversations = []
        this.initialSelectedBot = this.chatbots.find((bot) => bot.id === botId)
        await this.getConversationHistory(this.bot_id)
        this.isProcessing = false
      }
    },
    async handleConversation(conversationId) {
      this.isDefaultCard = false
      this.conversationId = conversationId
      this.messages = []
      this.ragResult = []
      await this.startConversation()
    },
    handleFileClick(event) {
      const link = event.target.closest('a[data-filename]')
      if (link) {
        event.preventDefault() // Prevent the default action
        const filename = link.getAttribute('data-filename')
        this.handleFileDownload(filename) // Call your download method
      }
    },
    handleFileDownload(filename) {
      console.log('Clicked', filename) // Debugging
      HTTPService.getfile(filename) // Your existing file download logic
    },
    handleConfirmDeleteConversation(conversationId) {
      this.delete_conversation_id = conversationId
      this.showConfirmDeleteConversationPopup = true
    },
    handleDeleteMode(isDeleteMode) {
      this.isDeleteMode = isDeleteMode
    },
    togglePromptCollapse() {
      this.isPromptCollapsed = !this.isPromptCollapsed
    },
    parseMarkdown(text) {
      if (typeof text !== 'string') {
        return '' // Return the text as is if it's not a string
      }

      text = text.replaceAll('\\n', '\n')
      text = text.replaceAll('```markdown', '```')
      try {
        const renderer = new marked.Renderer()
        renderer.link = function (href, title, text) {
          // Renderer() seems to return different parameters depending on the version of marked installed...
          const link = {
            href: href.href ?? href,
            text: href.text ?? text,
          }
          if (link.href.startsWith('/files/')) {
            // Extract the filename from the path (e.g., "/files/<filename>")
            const filename = link.href.split('/').pop()
            return `<a href="#" data-filename="${filename}">${link.text}</a>`
          } else {
            return `<a target="_blank" href="${link.href}">${link.text}</a>`
          }
        }

        //text = text.replaceAll('```', '')
        let parsed = marked(text, { renderer: renderer })

        // format Bing's source links more nicely
        // 1. replace "[^1^]" with "[1]" (during progress streams)
        parsed = parsed.replace(/\[\^(\d+)\^]/g, '<strong>[$1]</strong>')
        // 2. replace "^1^" with "[1]" (after the progress stream is done)
        parsed = parsed.replace(/\^(\d+)\^/g, '<strong>[$1]</strong>')

        const sanitizedHtml = DOMPurify.sanitize(parsed, {
          ADD_TAGS: ['iframe'],
          ADD_ATTR: [
            'allow',
            'allowfullscreen',
            'frameborder',
            'scrolling',
            'srcdoc',
            'target',
          ],
        })
        const container = document.createElement('div')
        container.innerHTML = sanitizedHtml
        // Prismでハイライト
        Prism.highlightAllUnder(container)
        // 🟢 HTMLを返す
        return container.innerHTML
      } catch (err) {
        console.error('ERROR', err)
        return null
      }
    },
    async startConversation() {
      try {
        // スクロールを末尾にまで移動させる
        this.isHistoryLoaded = true
        const response = await HTTPService.get_conversation(this.conversationId)
        for (const message of response.data) {
          const text = message.text
          const is_user = message.is_user
          const vdb_results = message.vdb_results
          const is_preparing = false
          this.messages.push({ text, is_user, vdb_results, is_preparing })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async listConversation(conversationId) {
      try {
        const response = await HTTPService.get_conversation(conversationId)

        // is_user === true の最初のメッセージを取得
        const firstUserMessage = response.data.find(
          (msg) => msg.is_user === true,
        )

        if (firstUserMessage) {
          const id = conversationId
          const text = firstUserMessage.text
          this.conversations.push({ id, text })
        }
      } catch (error) {
        console.log(error)
      }
    },

    autoResize() {
      const textarea = this.$refs.messageArea.querySelector('textarea')
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    },

    openFileBrowser() {
      this.$refs.fileInput.click()
    },

    setDefaultPrompt() {
      this.promptValue = this.getDefaultPrompt
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files)
      this.validateAndAttachFiles(files)
    },

    handleDrop(event) {
      event.preventDefault()
      const files = Array.from(event.dataTransfer.files)
      this.validateAndAttachFiles(files)
    },

    handleDragOver(event) {
      event.preventDefault()
    },

    //handleFiles(files) {
    //  this.attachedFiles.push(...files)
    //  this.$refs.fileInput.value = ''
    //  this.sendMessage()
    //},

    removeFile(index) {
      this.attachedFiles.splice(index, 1)
    },

    isImageFile(file) {
      return file.type.startsWith('image/')
    },

    getFilePreview(file) {
      return URL.createObjectURL(file)
    },

    getFileExtension(file) {
      return file.name.split('.').pop().toUpperCase()
    },

    handleShowErrorPopup() {
      this.showErrorPopup = true
      this.errorMessage =
        'RAGっチャオの設定中です。<br/>恐れ入りますが、他の機能をご利用ください。'
    },
    handleSelectedModel(selectedModel) {
      this.selectedModel = selectedModel
    },
    handleSelectedModelLabel(label) {
      this.selectedModelLabel = label
    },
    validateAndAttachFiles(files) {
      const allowedTypes = [
        'application/pdf',
        'text/csv',
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'image/jpeg',
        'image/png',
      ]

      for (let file of files) {
        // MB換算
        const fileSizeMB = file.size / (1024 * 1024)
        // 画像かどうか判定
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        // 上限切り替え
        const maxSize = isImage ? this.maxPerImageFileMB : this.maxPerFileMB

        if (fileSizeMB > maxSize) {
          this.errorMessage = isImage
            ? `・「${file.name}」はサイズが大きすぎます。\r\n・画像は最大 ${this.maxPerImageFileMB}MB までアップロード可能です。\r\n・圧縮して再度お試しください。`
            : `・「${file.name}」はサイズが大きすぎます。\r\n・アップロードは１ファイル最大 ${this.maxPerFileMB}MBまでとなります。\r\n・ファイルを圧縮するか、分割してお試しください。`
          this.showErrorPopup = true
          return
        }

        if (!allowedTypes.includes(file.type)) {
          this.errorMessage =
            'ファイルの読み込むことができませんでした。\r\n' +
            '以下のファイル形式に対応しています。\r\n' +
            '「pdf, csv, txt, doc, docx, xls, xlsx, ppt, pptx, png, jpg, jpeg」'
          this.showErrorPopup = true
          return
        }
      }

      this.attachedFiles.push(...files)
    },

    handleSendMessage(messageText) {
      this.userInput = messageText
      this.sendMessage()
    },

    async sendMessage() {
      if (!this.bot_id) {
        this.handleShowErrorPopup()
        return
      }
      if (!this.userInput && this.attachedFiles.length === 0) return
      this.isDefaultCard = false
      // 自動スクロールを停止
      this.isHistoryLoaded = false
      this.isProcessing = true

      // Extract file names and encode them
      const fileNames = this.attachedFiles.map((file) =>
        encodeURIComponent(file.name),
      )

      // Join the file names into a single string
      const filesParam = fileNames.join(',')
      // Clear the attached files
      //this.attachedFiles = []

      if (this.userInput) {
        this.addMessage(this.userInput, true)
        this.messageIndex++
      }

      const url = `${process.env.VUE_APP_API_URL}/conversation`
      try {
        //let token = StorageService.getToken()
        const auth = useAuthStore()

        const formData = new FormData()

        // 通常パラメータ
        formData.append('bot_id', this.bot_id)
        formData.append('user_input', this.userInput)
        formData.append('conversation_id', this.conversationId)
        formData.append('username', this.$store.state.email)
        formData.append('prompt', this.promptValue)
        formData.append('model', this.selectedModel)
        formData.append('showRagResults', true)
        formData.append('files', filesParam)

        // ファイル
        if (this.attachedFiles) {
          for (let i = 0; i < this.attachedFiles.length; i++) {
            formData.append('attachedFiles[]', this.attachedFiles[i])
          }
        }

        this.abortController = new AbortController()
        this.isStreaming = true

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            //'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.token}`,
            //Accept: 'application/json',
          },
          //body: JSON.stringify(requestBody),
          body: formData,
          signal: this.abortController.signal,
        })

        if (response && response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
          return
        }

        this.isProcessing = false

        if (!response.ok) {
          const errorBody = await response.json()
          this.errorMessage =
            errorBody.error ||
            `HTTP error! status: ${response.status} ${response.statusText}`
          this.showErrorPopup = true
          throw new Error(this.errorMessage)
        } else {
          this.attachedFiles = []
          this.conversations = []
          await this.getConversationHistory(this.bot_id)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()

        let buffer = ''
        let isProcessingJson = true

        // Initialize the message
        this.addMessage('', false)

        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.abortController.signal.aborted) {
            break
          }

          const { done, value } = await reader.read()
          if (done) break

          buffer += decoder.decode(value, { stream: true })

          if (isProcessingJson) {
            const jsonEndIndex = buffer.indexOf('\r\n--frame\r\n')
            if (jsonEndIndex !== -1) {
              const jsonPart = buffer.slice(0, jsonEndIndex)
              const match = jsonPart.match(/\{[\s\S]*\}/)
              if (match) {
                //this.ragResult = JSON.parse(match[0]).vdb_results
                this.messages[this.messageIndex].vdb_results = JSON.parse(
                  match[0],
                ).vdb_results
              }
              buffer = buffer.slice(jsonEndIndex + 8) // 8 is the length of '\r\n--frame'
              isProcessingJson = false
            }
          } else {
            const lines = buffer.split('\n')
            buffer = lines.pop() || '' // Keep the last incomplete line in the buffer

            for (const line of lines) {
              if (line.startsWith('data:')) {
                const data = line.slice(6)

                if (data === '[DONE]') {
                  this.addMessage('', false, null, false)
                  this.isStreaming = false
                  this.abortController = null
                  this.messageIndex++
                  return
                }

                // assistant_message_idを含むJSONか確認
                try {
                  const json = JSON.parse(data)
                  if (json.assistant_message_id) {
                    this.assistantMessageId = json.assistant_message_id
                    continue // 表示せずスキップ（チャットには表示しない）
                  }
                } catch (e) {
                  // dataがJSONでない場合は無視して通常処理
                }

                this.addMessage(data, false)
              }
            }
          }
        }
      } catch (error) {
        this.isProcessing = false
        console.error(error)
        if (error.name === 'AbortError') {
          console.log('stream stopped')
          this.addMessage('', false, null, false)
          this.isStreaming = false
          this.abortController = null
          this.messageIndex++
          return
        }
        if (error.response && error.response.data.error) {
          this.errorMessage = error.response.data.error
          this.showErrorPopup = true
        } else {
          this.errorMessage =
            'ただいま、選択された言語モデルにアクセス集中しています。<br />回答の生成に通常より時間がかかっています。<br />しばらくお待ちください。'
          this.showErrorPopup = true
        }
      }
    },

    cleanupObjectURLs() {
      this.messages.forEach((message) => {
        if (message.file && message.file.preview) {
          URL.revokeObjectURL(message.file.preview)
        }
      })
    },

    // Add this to clean up object URLs when the component is destroyed
    beforeDestroy() {
      this.cleanupObjectURLs()
    },

    async getConversationHistory(chatbotId) {
      try {
        const response = await HTTPService.get_conversation_history(chatbotId)
        if (response.data && response.data.length > 0) {
          const history = response.data.sort(
            (a, b) => new Date(b.created) - new Date(a.created),
          )

          for (const data of history) {
            //this.conversationId = data.conversation_id
            // 会話の詳細を取得
            //await this.listConversation(data.conversation_id)

            // 2025.10.01
            const id = data.conversation_id
            const text = data.message
            this.conversations.push({ id, text })
          }
        } else {
          console.warn('No conversation history found.')
        }
      } catch (error) {
        console.error(error)
      }
    },

    async getChatbots() {
      try {
        // 管理画面のチャットボット一覧から遷移した場合
        if (this.initChatBot) {
          this.bot_id = this.initChatBot.id
          this.botName = this.initChatBot.name
          this.initialSelectedBot = this.initChatBot
          await this.getConversationHistory(this.bot_id)

          // GETパラメータにbot_idが付加されていた場合
        } else if (this.$route.query.bot_id) {
          const response = await HTTPService.get_chatbots(
            NAV_MASTER.RAG_CHAT,
            getTenantId(this.$route),
          )

          // URLからbot_idを取得
          const botId = this.$route.query.bot_id

          // 公開済みチャットボット一覧から検索（事前に this.chatbots にセット済み想定）
          const targetBot = response.data.find(
            (bot) => String(bot.id) === String(botId),
          )

          if (targetBot) {
            this.$store.commit('updateInitChatBot', targetBot)
            this.bot_id = this.initChatBot.id
            this.botName = this.initChatBot.name
            this.initialSelectedBot = this.initChatBot
            await this.getConversationHistory(this.bot_id)
          } else {
            // bot_id が不正なら通常のルートへ
            this.$router.push({ name: 'Home' })
          }
        } else {
          this.$router.push({
            name: 'Home',
          })
        }
      } catch (error) {
        this.$emit('change-active-component', {
          component: 'Login',
        })
      }
    },

    async createChatbot() {
      this.showModal = false
      const formData = new FormData()
      if (this.attachedFiles) {
        for (let i = 0; i < this.attachedFiles.length; i++) {
          formData.append('files[]', this.attachedFiles[i])
        }
      }
      if (this.botName) {
        formData.append('data', JSON.stringify({ bot_name: this.botName }))
      }
      if (this.bot_id) {
        formData.append('bot_id', this.bot_id)
      }

      // 相談しチャオ
      formData.append('nav_id', NAV_MASTER.RAG_CHAT)

      if (this.bot_id) this.isUpdatingChatbot = true
      else this.isCreatingChatbot = true
      await HTTPService.createChatbot(formData)
        .then((response) => {
          this.showConfirmation = true
          this.bot_id = response.data.bot_id
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error
            this.showErrorPopup = true
            if (
              error.response &&
              (error.response.status === 423 || error.response.status === 424)
            ) {
              this.planerror = true
            }
          } else {
            this.errorMessage = 'Failed to create chatbot: ' + error.response
            this.showErrorPopup = true
          }
        })
        .finally(() => {
          this.isCreatingChatbot = false
          this.isUpdatingChatbot = false
        })
    },

    async closeConversation() {
      try {
        const data = {
          conversation_ids: this.delete_conversation_id,
        }
        this.isProcessing = true
        await HTTPService.delete_conversation(data)
        this.conversations = []
        await this.getConversationHistory(this.bot_id)
      } catch (error) {
        console.log(error)
      } finally {
        this.handleInitChat()
        this.isDeleteMode = false
        this.isProcessing = false
        this.showConfirmDeleteConversationPopup = false
      }
    },

    addMessage(text, is_user, file = null, is_preparing = true) {
      if (this.messageIndex >= 0 && is_user === false) {
        // if first message then just push
        if (!this.messages[this.messageIndex]) {
          this.messages.push({
            text: '',
            is_user: is_user,
            is_preparing: is_preparing,
            file: null,
          })
        } else {
          this.messages[this.messageIndex].text += text
          this.messages[this.messageIndex].is_user = is_user
          this.messages[this.messageIndex].is_preparing = is_preparing
        }
      } else {
        this.messageIndex = this.messages.length

        this.messages.push({
          text: file ? '' : text,
          is_user,
          is_preparing: false,
          file: file || null,
        })
        this.messageIndex = this.messages.length - 1
      }

      // Scroll to the bottom of the chatbot conversation
      //this.$refs.chatbotConversation.scrollTop =
      //  this.$refs.chatbotConversation.scrollHeight
    },
    endConversation() {
      // this.$router.push('/chatbot-dashboard')
    },
    downloadFile(bot_id, filename) {
      const data = {
        bot_id: bot_id,
        filename: filename.replace(/ /g, '_'),
      }

      HTTPService.getfile(data)
    },
    closeErrorPopup() {
      this.showErrorPopup = false
      this.errorMessage = ''
    },
    closeConfirmDeleteConversationPopup() {
      this.showConfirmDeleteConversationPopup = false
    },
  },
}
</script>

<style scoped>
.chatbot {
  height: 100%;
  width: 80%;
  margin: 0 auto;
}

.chatbot-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
}

.chatbot-conversation {
  flex: 1;
  padding: 10px;
  overflow-y: scroll;
  overflow: auto;
  background-color: rgb(240, 245, 245);
}

.chatbot-message {
  margin: 10px 0;
}

.user-message {
  text-align: right;
}

.bot-message {
  text-align: left;
}

.chatbot-message div {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  max-width: 80%;
}

.chatbot-message div:last-child {
  margin-bottom: 0;
}

.chatbot-message.user-message div {
  color: #fff;
}

.chatbot-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  margin: 10px 30px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin: 0px 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 50%;
}

.drop-zone:hover {
  background-color: #f0f0f0;
}

input[type='text'] {
  flex: 1;
  margin-right: 10px;
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
  line-height: normal;
  height: 50px;
}

.chatbot-header {
  display: flex;
  flex-direction: row;
  background-color: rgb(173, 92, 92);
  width: 100%;
  /* height: 70px; */
  padding-top: 10px;
  padding-bottom: 10px;
  padding-inline: 10px;
  font-size: 1.25rem;
  margin-bottom: 0px;
}

.chatbot-heading {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.2;
}

p {
  margin-bottom: 0px;
  font-size: 16px;
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.centered-image {
  max-width: 40px;
  max-height: 40px;
}

.model-selector {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  background-color: none; /* Or any color that matches your design */
}

.model-selector select {
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: white;
  font-size: 14px;
}

.message-area {
  width: 100%;
  transition: border 0.2s ease;
}

.message-area[draggable='true'] {
  cursor: move;
}

.message-area[draggable='true']:hover {
  border: 1px dashed #ccc;
}

.message-area textarea,
.chatbot-input textarea {
  width: 100%;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 16px;
  max-height: 150px;
  overflow-y: auto;
  border: none;
}

textarea:focus,
input:focus {
  outline: none;
}

.file-preview-area {
  display: flex;
  width: 100%; /* Makes it take full width of parent */
  margin: 5px 5px 10px 5px;
  height: 130px;
  overflow-y: hidden;
  overflow-x: auto;
  align-items: center;
}

.file-preview-scroll {
  display: inline-flex; /* Changed to inline-flex */
  flex-wrap: nowrap;
}

.file-preview {
  flex: 0 0 auto; /* Prevents shrinking */
  margin-right: 10px;
  text-align: center;
  position: relative;
}

.file-preview img {
  max-width: 80px;
  max-height: 80px;
  object-fit: cover;
  border-radius: 5px;
}

.image-preview {
  display: inline-block;
  text-align: center;
  margin: 5px 0;
}

.image-preview img {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 5px;
}

.image-preview span {
  display: block;
  font-size: 0.8em;
  color: #fff;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
}

.file-icon {
  width: 80px;
  height: 80px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 5px;
  color: #000 !important;
}

.remove-file-btn {
  background-color: #333;
  color: white;
  border: none;
  padding: 0x;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 10px;
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px; /* set the width */
  height: 20px; /* set the height to be the same as width */
  padding: 0; /* remove padding */
}

.remove-file-btn:hover {
  background-color: #ff1a1a;
}

.parent-div {
  display: flex;
  flex-direction: column; /* Đảm bảo các phần tử xếp chồng lên nhau */
  width: 95%; /* Điều chỉnh kích thước phù hợp */
}

.input-container {
  display: flex;
  flex-direction: column;
  background-color: #f3f5f7;
}

.system-prompt-label {
  font-weight: bold;
  margin: 0px 0px 0px 30px;
  font-size: 14px;
  cursor: pointer;
}

.toggle-icon {
  display: inline-block;
  margin-right: 5px;
  transition: transform 0.3s ease;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

.chatbot-container.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.processing-message {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.loading-icon-wrapper {
  margin-bottom: 10px;
}

.loading-icon {
  width: 50px;
  height: 50px;
}

.rag-results-table {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.rag-results-table h3 {
  margin-bottom: 10px;
}

.rag-results-table table {
  width: 100%;
  border-collapse: collapse;
}

.rag-results-table th,
.rag-results-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.rag-results-table th {
  background-color: #f6f9fe;
  font-weight: bold;
}

.rag-results-table tr:hover {
  background-color: #f5f5f5;
}

.button-container {
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: auto;
  margin-bottom: 5px;
}
</style>
